import { ReactNode } from 'react'

export type PanelVariant = 'primary' | 'default' | 'danger' | 'plain'

const BOOTSTRAP_VARIANTS: Readonly<Record<PanelVariant, string>> = {
  primary: 'panel panel-primary hc-container',
  default: 'panel panel-default',
  danger: 'panel panel-danger',
  plain: 'panel',
}

export function PanelHeading({
  children,
  className = '',
  ...rest
}: { children?: ReactNode; className?: string } & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`panel-heading ${className}`.trim()} {...rest}>
      {children}
    </div>
  )
}

export function PanelTitle({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <h4 className={`panel-title ${className}`.trim()}>{children}</h4>
}

export function PanelBody({
  children,
  className = '',
  ...rest
}: { children?: ReactNode; className?: string } & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`panel-body ${className}`.trim()} {...rest}>
      {children}
    </div>
  )
}

export function Panel({
  children,
  variant = 'primary',
  className = '',
  ...rest
}: { children?: ReactNode; variant?: PanelVariant; className?: string } & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`${BOOTSTRAP_VARIANTS[variant]} ${className}`.trim()} {...rest}>
      {children}
    </div>
  )
}
